/**
 * @desc 平台-平台详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformResponseDto>;
export function request(platformKey: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platform/details/${platformKey}`, {
      method: "GET",

      ...options,
    }),
  );
}
